import { blockDef, mergeStyles, type DocNode, type EmailDocument, type StyleProps } from "@edm/schema";
import type { CSSProperties } from "react";

/** Client-side approximation of the renderer's style resolution (registry
 * defaults → document layer → node overrides). Brand kit layer joins in M4. */
export function effectiveStyles(doc: EmailDocument, node: DocNode): StyleProps {
    return mergeStyles(blockDef(node.type).defaultStyles, doc.styles[node.type], node.styles);
}

export function toCss(s: StyleProps, fontFallback: string): CSSProperties {
    return {
        paddingTop: s.paddingTop,
        paddingRight: s.paddingRight,
        paddingBottom: s.paddingBottom,
        paddingLeft: s.paddingLeft,
        backgroundColor: s.backgroundColor === "transparent" ? undefined : s.backgroundColor,
        color: s.color,
        fontFamily: s.fontFamily ?? fontFallback,
        fontSize: s.fontSize,
        lineHeight: s.lineHeight,
        fontWeight: s.fontWeight,
        textAlign: s.textAlign,
        borderRadius: s.borderRadius,
        letterSpacing: s.letterSpacing,
        textTransform: s.textTransform,
    };
}
